import React, { createElement } from 'react';
import './index.css';
import { render } from 'react-dom';
import { App } from './App';
// Preconnect to critical origins for faster resource loading
const preconnects = [{
  href: 'https://fonts.googleapis.com',
  crossorigin: false
}, {
  href: 'https://fonts.gstatic.com',
  crossorigin: true
}, {
  href: 'https://cdn.magicpatterns.com',
  crossorigin: true
}];
preconnects.forEach(({
  href,
  crossorigin
}) => {
  const link = document.createElement('link');
  link.rel = 'preconnect';
  link.href = href;
  if (crossorigin) link.crossOrigin = 'anonymous';
  document.head.appendChild(link);
});
render(<App data-id="element-517" />, document.getElementById('root'));